import React from 'react';
import ReactLoading from 'react-loading';
import PropTypes from 'prop-types';
import LocalizedMessage from 'react-l10n';
import { handleSignInToOrder } from '../../actions/userActions';

function ProductVariationListItemActionButton(props) {
    const {
        item,
        addToCart,
        isLoading,
        setButtonLoading,
        cartQty,
        loggedIn,
    } = props;
    const { ID, BuyableID, MinOrderQuantity } = item;

    const handleAddToCart = (e) => {
        e.preventDefault();

        setButtonLoading(ID, true);

        const payload = {
            BuyableID,
            TotalUnitItems: cartQty,
        };

        addToCart(payload, {
            success: () => {
                // toggle cart
                // toggleCart();
            },
            always: () => {
                setButtonLoading(ID, false);
            },
        });
    };
    const renderSignInToOrderButton = () => {
        return (
            <button
                className={`button products-data-table-helper__button form__submit`}
                onClick={handleSignInToOrder}
            >
                <span>
                    <LocalizedMessage id={'SIGN_IN_TO_ORDER'} />
                </span>
            </button>
        );
    };
    const renderAddToCartButton = () => {
        const isAddToCartDisabled = cartQty < MinOrderQuantity;

        return (
            <button
                className={`button products-data-table-helper__button form__submit ${isAddToCartDisabled &&
                    'button--disabled'}`}
                onClick={handleAddToCart}
                disabled={
                    isAddToCartDisabled ||
                    (window.localeCountry == 'South Africa' &&
                    window.currentOrderPaymentMethod ==
                                'order-card-authorization-payfast' &&
                        window.isEditOrder)
                }
            >
                {isLoading == true ? (
                    <ReactLoading
                        className='button__spinner'
                        type='spin'
                        color='white'
                        height={20}
                        width={20}
                    />
                ) : (
                    <React.Fragment>
                        <span>
                            <LocalizedMessage id={'ADD_TO_CART'} />
                        </span>
                        <i className='icon icon-add-to-cart' />
                    </React.Fragment>
                )}
            </button>
        );
    };

    // Don't print anything until we have buyableID
    if (typeof BuyableID == 'undefined') {
        return '';
    }

    return (
        <React.Fragment>
            {loggedIn ? renderAddToCartButton() : renderSignInToOrderButton()}
        </React.Fragment>
    );
}

// default props
ProductVariationListItemActionButton.defaultProps = {
    item: {},
};
// validate props
ProductVariationListItemActionButton.propTypes = {
    item: PropTypes.any.isRequired,
};

export default ProductVariationListItemActionButton;
